export function isAuthenticated(state) {
  return state.isAuthenticated;
}
export function me(state) {
  return state.me;
}